// src/components/BGP/BgpTabs.tsx
import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function BgpTabs() {
    const location = useLocation();

    // Checar las rutas exactas
    const isLicensedActive =
        location.pathname === "/reflector/management/instances/licensed";
    const isUnlicensedActive =
        location.pathname === "/reflector/management/instances/unlicensed";
    const isHighAvailabilityActive =
        location.pathname === "/reflector/management/instances/highavailability";
    const isHealthCheckActive =
        location.pathname === "/reflector/management/instances/healthcheck";
    const isSyslogActive =
        location.pathname === "/reflector/management/instances/syslog";

    return (
        <div
            className="
        inline-flex
        max-w-full
        rounded-md
        border border-semantic-border-secondary
        overflow-x-auto
        mt-2
      "
        >
            {/* Licensed */}
            <Link
                to="/reflector/management/instances/licensed"
                className={`
          px-6 py-3
          min-w-[120px]
          whitespace-nowrap
          text-sm font-medium
          transition-colors
          ${isLicensedActive
                        ? "bg-white text-black"
                        : "bg-semantic-bg-primary text-semantic-text-secondary"
                    }
        `}
            >
                Licensed
            </Link>

            {/* Unlicensed */}
            <Link
                to="/reflector/management/instances/unlicensed"
                className={`
          px-6 py-3
          min-w-[120px]
          whitespace-nowrap
          text-sm font-medium
          border-l border-semantic-border-secondary
          transition-colors
          ${isUnlicensedActive
                        ? "bg-white text-black"
                        : "bg-semantic-bg-primary text-semantic-text-secondary"
                    }
        `}
            >
                Unlicensed
            </Link>

            {/* High Availability */}
            <Link
                to="/reflector/management/instances/highavailability"
                className={`
          px-6 py-3
          min-w-[120px]
          whitespace-nowrap
          text-sm font-medium
          border-l border-semantic-border-secondary
          transition-colors
          ${isHighAvailabilityActive
                        ? "bg-white text-black"
                        : "bg-semantic-bg-primary text-semantic-text-secondary"
                    }
        `}
            >
                High Availability
            </Link>

            {/* Health Check */}
            <Link
                to="/reflector/management/instances/healthcheck"
                className={`
          px-6 py-3
          min-w-[120px]
          whitespace-nowrap
          text-sm font-medium
          border-l border-semantic-border-secondary
          transition-colors
          ${isHealthCheckActive
                        ? "bg-white text-black"
                        : "bg-semantic-bg-primary text-semantic-text-secondary"
                    }
        `}
            >
                Health Check
            </Link>

            {/* Syslog */}
            <Link
                to="/reflector/management/instances/syslog"
                className={`
          px-6 py-3
          min-w-[120px]
          whitespace-nowrap
          text-sm font-medium
          border-l border-semantic-border-secondary
          transition-colors
          ${isSyslogActive
                        ? "bg-white text-black"
                        : "bg-semantic-bg-primary text-semantic-text-secondary"
                    }
        `}
            >
                Syslog
            </Link>
        </div>
    );
}
